import Vue from 'vue';
import VueI18n from 'vue-i18n';
import numberFormats from '@/i18n/numberFormats';
import {LANGUAGE} from '@/constant/language';

// docs: https://docs.google.com/spreadsheets/d/1uaTT4p-n18ZZnSAjd_SINV2oiZhvBVbiVRaYUmE04QU/edit#gid=0
import zhTW from '@/i18n/lang/zh-TW.json';
import zhCN from '@/i18n/lang/zh-CN.json';
import enUS from '@/i18n/lang/en-US.json';
import jaJP from '@/i18n/lang/ja-JP.json';

import {getLocale} from '@/i18n/utils.js';

const locale = getLocale();

Vue.use(VueI18n);

const missingKeys = {};

const i18n = new VueI18n({
  locale,
  messages: {
    [LANGUAGE.ZH_TW]: zhTW,
    [LANGUAGE.ZH_CN]: zhCN,
    [LANGUAGE.EN_US]: enUS,
    [LANGUAGE.JA_JP]: jaJP,
  },
  numberFormats,
  missing: (locale, key, vm, values) => {
    console.log('missing key', JSON.stringify(missingKeys), key);
    let result = key;
    values?.forEach((object) => {
      if (!object) return;
      Object.keys(object).forEach((key) => {
        result = result.replaceAll(`{${key}}`, object[key]);
      });
    });
    return result;
  },
});

export default i18n;
